<template>
  <div
    class="container"
    @dragover.prevent="dragOver"
    @dragleave.prevent="dragLeave"
    @drop.prevent="drop"
  >
    <div class="section-header">
      <h3 class="section-title">House Images</h3>
      <b-button variant="primary" @click="append">Upload Image</b-button>
    </div>
    <div class="drop" v-show="dropped"></div>
    <div v-show="error" class="error">{{ error }}</div>
    <div v-show="Imgs.length === 0" class="beforeUpload">
      <input
        type="file"
        style="z-index: 1"
        accept="image/*"
        ref="uploadInput"
        @change="previewImgs"
        multiple
      />
      <p class="mainMessage">
        {{ uploadMsg ? uploadMsg : "Click to upload or drop your images here" }}
      </p>
    </div>

    <div class="imgsPreview" v-show="Imgs.length > 0">
      <div
        class="imageHolder"
        v-for="(img, i) in Imgs.filter(v => v.image_type_id === 1)"
        :key="img.id"
        @click="openPreview(i)"
        style="cursor: pointer;"
      >
        <img :src="img.fullfilepath" />
        <span class="check-cover" style="color: white">
          <input type="checkbox" name="is_cover" v-if="img.is_cover" checked disabled />
          <input type="checkbox" name="is_cover" @click.stop="iscover(img.id)" v-else />
        </span>
          
        <span class="delete" style="color: white" @click.stop="deleteconfirm(img.id)">
          <svg
            class="icon"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
            />
          </svg>
        </span>
      </div>
    </div>

    <div v-if="showPreview" class="fullscreen-modal" @click.self="closePreview">
      <img :src="ImgsFiltered[currentIndex].fullfilepath" class="fullscreen-image" />

      <button class="nav-btn left" @click.stop="prevImage">‹</button>
      <button class="nav-btn right" @click.stop="nextImage">›</button>

      <button class="close-btn" @click="closePreview">×</button>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import axios from '@axios'
import { BButton } from 'bootstrap-vue'

export default {
  name: "VueUploadImages",
  components:{
    draggable, BButton,
  },
  data() {
    const userStorage = JSON.parse(localStorage.getItem('userData'))

    return {
      error: "",
      files: [],
      dropped: 0,
      Imgs: [],
      input:{
          base64:''
      },
      pid:'',
      showPreview: false,
      currentIndex: 0,
      image_type_id: 1,
      created_by: userStorage?.id || null,
      updated_by: userStorage?.id || null,
    };
  },
  props: {
    max: Number,
    id: String,
    uploadMsg: String,
    maxError: String,
    fileError: String,
    clearAll: String,
  },
  created(){
    this.pid = this.id;
    this.getImages('');
  },
  methods: {
    openPreview(index) {
      this.currentIndex = index;
      this.showPreview = true;
    },
    closePreview() {
      this.showPreview = false;
    },
    prevImage() {
      if (this.currentIndex === 0) {
        this.currentIndex = this.ImgsFiltered.length - 1;
      } else {
        this.currentIndex--;
      }
    },
    nextImage() {
      if (this.currentIndex === this.ImgsFiltered.length - 1) {
        this.currentIndex = 0;
      } else {
        this.currentIndex++;
      }
    },
    dragOver() {
      this.dropped = 2;
    },
    deleteconfirm(id){
      this.$bvModal
        .msgBoxConfirm('Please confirm that you want to delete Image ID.'+id, {
          title: 'Please Confirm',
          size: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if(value === true){
            axios.delete('/house/v1/delete-image/'+id).then(res=>{
              this.getImages('');
            })
          }
        })
    },
    async getImages(){
      let images = await axios.get('/house/v1/house-image/'+this.pid);
      this.Imgs =  [];

      if(images.data.data){
        this.Imgs = images.data.data
      }
    },
    dragLeave() {},
    drop(e) {
      let status = true;
      let files = Array.from(e.dataTransfer.files)

      if (e && files) {
        files.forEach((file) => {
          if (file.type.startsWith("image") === false) status = false;
        });

        if (status == true) {
          if (
            this.$props.max &&
            files.length + this.files.length > this.$props.max
          ) {
            this.error = this.$props.maxError
              ? this.$props.maxError
              : `Maximum files is` + this.$props.max;
          } else {
            this.files.push(...files);
            this.previewImgs();
          }
        } else {
          this.error = this.$props.fileError
            ? this.$props.fileError
            : `Unsupported file type`;
        }
      }

      this.dropped = 0;
    },
    append() {
      this.$refs.uploadInput.click();
    },
    readAsDataURL(file) {
      return new Promise(function (resolve, reject) {
        let fr = new FileReader();
        fr.onload = function () {
          resolve(fr.result);
        };
        fr.onerror = function () {
          reject(fr);
        };
        fr.readAsDataURL(file);
      });
    },
    iscover(image_id){
        axios.put('/house/v1/update-cover/'+this.pid+'/'+image_id).then(res=>{
            this.getImages('');
        });
    },
    deleteImg(index) {
      axios.delete('/house/v1/delete-image/'+id)

      this.Imgs.splice(index, 1);
      this.$emit("changed", this.files);
      this.$refs.uploadInput.value = null;
    },
    previewImgs(event) {
        if (
            this.$props.max &&
            event &&
            event.currentTarget.files.length + this.files.length > this.$props.max
        ) {
            this.error = this.$props.maxError
            ? this.$props.maxError
            : `Maximum files is` + this.$props.max;
            return;
        }

        if (this.dropped === 0 && event?.currentTarget?.files) {
            this.files.push(...event.currentTarget.files);
        }

        this.error = "";
        this.$emit("changed", this.files);

        if (!this.files.length) return;

        this.files.forEach((file) => {
            const formData = new FormData();
            formData.append("file", file);
            formData.append("image_type_id", this.image_type_id);
            formData.append("house_id", this.pid);
            formData.append("created_by", this.created_by);

            axios
                .post(`/house/v1/upload-image/${this.pid}`, formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                })
                .then((res) => {
                    this.getImages('');
                })
                .catch((err) => {
                    console.error("Upload error:", err);
                });
            });

            this.files = [];
    },
    reset() {
        this.$refs.uploadInput.value = null;
        this.Imgs = [];
        this.files = [];
        this.$emit("changed", this.files);
    },
  },
    computed: {
        ImgsFiltered() {
            return this.Imgs.filter(v => v.image_type_id === 1);
        },
    },
};
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
  background: #f7fafc;
  border: 0.5px solid #a3a8b1;
  border-radius: 10px;
  padding: 30px;
  position: relative;
}
.drop {
  width: 100%;
  height: 100%;
  top: 0;
  border-radius: 10px;
  position: absolute;
  background-color: #f4f6ff;
  left: 0;
  border: 3px dashed #a3a8b1;
}
.error {
  text-align: center;
  color: red;
  font-size: 15px;
}
.beforeUpload {
  position: relative;
  text-align: center;
}
.beforeUpload input {
  width: 100%;
  margin: auto;
  height: 100%;
  opacity: 0;
  position: absolute;
  background: red;
  display: block;
}
.beforeUpload input:hover {
  cursor: pointer;
}
.beforeUpload .icon {
  width: 150px;
  margin: auto;
  display: block;
}
.imgsPreview .imageHolder {
  width: 150px;
  height: 150px;
  background: #fff;
  position: relative;
  border-radius: 10px;
  margin: 5px 5px;
  display: inline-block;
}
.imgsPreview .imageHolder img {
  object-fit: cover;
  width: 100%;
  height: 100%;
}
.imgsPreview .imageHolder .delete {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 29px;
  height: 29px;
  color: #fff;
  background: red;
  border-radius: 50%;
}
.imgsPreview .imageHolder .delete:hover {
  cursor: pointer;
}
.imgsPreview .imageHolder .delete .icon {
  width: 66%;
  height: 66%;
  display: block;
  margin: 4px auto;
}
.imgsPreview .imageHolder .plus {
  color: #2d3748;
  background: #f7fafc;
  border-radius: 50%;
  font-size: 21pt;
  height: 30px;
  width: 30px;
  text-align: center;
  border: 1px dashed;
  line-height: 23px;
  position: absolute;
  right: -42px;
  bottom: 43%;
}
.plus:hover {
  cursor: pointer;
}
.imgsPreview .imageHolder .check-cover {
  position: absolute;
  top: 4px;
  left: 10px;
  color: #fff;
  border-radius: 50%;
}
.clearButton {
  color: #2d3748;
  position: absolute;
  top: 7px;
  right: 7px;
  background: none;
  border: none;
  cursor: pointer;
}
.fullscreen-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  overflow: hidden;
}
.fullscreen-image {
  width: 100%;
  height: auto;
  max-width: 1280px;
  max-height: 720px;
  object-fit: contain;
  border-radius: 4px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.4);
  transition: transform 0.3s ease;
}

@media (max-width: 1280px) {
  .fullscreen-image {
    max-width: 100vw;
    max-height: 100vh;
  }
}
.nav-btn,
.close-btn {
  position: absolute;
  background: none;
  border: none;
  font-size: 2.5rem;
  color: white;
  text-shadow: 0 0 5px black;
  cursor: pointer;
  z-index: 10000;
  user-select: none;
}
.nav-btn.left {
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
}
.nav-btn.right {
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
}
.close-btn {
  top: 20px;
  right: 20px;
}
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}
.section-title {
  font-size: 20px;
  font-weight: bold;
  margin: 0;
}
</style>